import React, { Component } from 'react';
import { connect } from 'dva';
import { Row, Col, Layout, Button, Icon, Input, Spin, message } from 'antd';
import '../../styles/containers/login/index.less';
import { framework_tool, utils_tool } from '@/tool'
import CustomFooter from './components/CustomFooter'
import LoginForm from './components/LoginForm'
import { footerMenuList } from './mock'

const { Header, Content, Footer } = Layout;
const { WizContainer, modelUtils } = framework_tool
const { JSEncrypt, Session } = utils_tool

const LoginHeader = () => (
  <div className="login-header">
    <div className="login-header-left">
      <img src={constants.files.sys_main_logo} alt="logo" />
      <h1>新培训平台在线学习</h1>
    </div>
  </div>
)

class Login extends WizContainer {

  componentName = 'login';

  constructor(props) {
    super(props);
    this.state = {
      uuid: '',//验证码对应令牌
      imageBase64: '',//bbase64型的图片验证码的
      password: '',
      username: '',
      captcha: '',//用户输入的验证码
      captchaText: '',//自动登录时兑换的验证码
      path: '/home',//登陆成功时跳转的页面
      record: {}
    }
  }

  componentWillMount() {
    this._checkAutoLogin()
    // 重置面包屑
    this.props.dispatch({
      type: 'tablayoutModels/setTopBar',
      payload: {
        data: [{ pathname: '/home' }],
        activeKey: '/home'
      }
    })
  }

  componentDidMount() {
    this._getCaptcha();
  }

  /**
   * 检查自动登陆及解析参数
   */
  _checkAutoLogin = () => {
    let sl = storage.getStorage('sl');
    if (!sl) { return }
    sl = sl.split("?sl=");
    let _sl = Base64.decode(sl[1]).split("base64Salt")
    let value = { userName: _sl[0], accountPassword: _sl[1], personId: _sl[2], params: _sl[3] || {}, path: sl[0].replace("#", "") }
    if (value['userName'] && value['accountPassword'] && value['personId'] && value['path']) {
      let record = value['params']
      record['personId'] = value['personId'];
      this.setState({
        authLogin: value,
        path: value['path'],
        record
      });
    }
    storage.removeStorage('sl');
  }

  /**
   * 进行自动登陆
   */
  _authLogin = (captchaText) => {
    let { userName, accountPassword, personId, path } = this.state['authLogin']
    this.setState({
      username: userName,
      password: accountPassword,
      captcha: captchaText,
      authLogin: undefined
    }, () => {
      this._onSubmit()
    })
  }

  propsAndStateOnChange = {
    imageCaptcha: this._imageCaptcha.bind(this),
    doLogin: this._doLogin.bind(this),
    captchaCode: this._captchaCode.bind(this)
  }

  _captchaCode(nextProps, nextState) {
    let { captchaCode } = nextProps
    if (captchaCode['success']) {
      this._authLogin(captchaCode['data'])
    } else {
      message.error(imageCaptcha['msg'] || '自动登陆失败,请稍后再试')
      return false;
    }
  }

  _imageCaptcha(nextProps, nextState) {
    let { imageCaptcha } = nextProps
    if (imageCaptcha['success']) {
      nextState['uuid'] = imageCaptcha['data'] && imageCaptcha['data']['uuid'];
      nextState['imageBase64'] = imageCaptcha['data'] && imageCaptcha['data']['imageBase64'];
      log.info('change captcha success')
      //如果是自动登陆 兑换验证码的内容
      if (this.state['authLogin']) {
        this._getCaptchaCode(imageCaptcha['data']['uuid'])
      } else {
        nextState['path'] = '/home'
      }
      return true;
    } else {
      message.error(imageCaptcha['msg'] || '获取验证码失败,请稍后再试')
      return false;
    }
  }

  _authLogin = (captchaText) => {
    let { userName, accountPassword, personId, path } = this.state['authLogin']
    this.setState({
      username: userName,
      password: accountPassword,
      captcha: captchaText,
      authLogin: undefined
    }, () => {
      this._onSubmit()
    })
  }
  _doLogin(nextProps, nextState) {
    let { doLogin } = nextProps
    if (doLogin['success'] && doLogin['data']) {
      let data = doLogin['data']
      storage.setStorage('user', data['user']);
      storage.setStorage('token', data['token']);
      storage.setStorage('isLogin', true);
      let _p = this.state.path.split('/')
      Session.set(_p[_p.length ? _p.length - 1 : 0], this.state['record']);
      wizNotice.success('登录成功');
      this.jumpPage('replace', this.state['path'], this.state['record'])
      return true;
    } else {
      wizNotice.error(doLogin['msg'] || '登录失败')
      nextState['captcha'] = ''
      this._getCaptcha();
      return true;
    }
  }

  /**
   * 获取验证码code
   */
  _getCaptchaCode(uuid) {
    this.doAction({
      path: 'captcha/getCaptchaCode',
      payload: {
        key: 'captcha@getCaptchaCode',
        apiParams: { uuid }
      },
    })
  }

  /**
   * 获取验证码
   */
  _getCaptcha() {
    this.doAction({
      path: 'captcha/getImageCaptcha',
      payload: {
        key: 'captcha@getImageCaptcha',
        apiParams: {}
      },
    })
  }

  /**
   * 账号/密码输入框
   */
  // _input() {
  //   return [
  //     <Input type='password' hidden autoComplete='new-password' />,
  //     <Input
  //       id='username'
  //       size='large'
  //       prefix={<Icon type='user' />}
  //       placeholder='请输入用户名'
  //       allowClear
  //       onChange={this._inputOnchange}
  //       onPressEnter={this._onSubmit}
  //       value={this.state['username']}
  //     />,
  //     <Input.Password
  //       id='password'
  //       size='large'
  //       prefix={<Icon type='lock' />}
  //       placeholder='请输入密码'
  //       onChange={this._inputOnchange}
  //       onPressEnter={this._onSubmit}
  //       value={this.state['password']}
  //     />
  //   ]
  // }




  /**
   * 登录触发事件
   */
  //username = this.state['username'], password = this.state['password'], captcha = this.state['captcha'], uuid = this.state['uuid']
  _onSubmit = (values = {}) => {
    const { uuid, captcha } = this.state
    const { username = this.state['username'], password = this.state['password'], captchaCode } = values
    const jse = new JSEncrypt();
    jse.setPublicKey(constants.env.sys_public_key);
    this.doAction({
      path: 'login/doLogin',
      payload: {
        key: 'login@doLogin',
        apiParams: {
          username: username,
          password: jse.encrypt(password),
          captchaCode: captcha || captchaCode,
          uuid,
          platform: 'PCmanager'
        }
      },
    })
  }

  /**
   * input内容改变事件
   */
  // _inputOnchange = ({ target }) => {
  //   this.setState({
  //     [target['id']]: target['value']
  //   })
  // }

  _render() {
    const { submitLoading, captchaLoading } = this.props;
    const { imageBase64, captcha } = this.state;
    const loginFormProps = {
      imageBase64,
      captchaLoading,
      submitLoading,
      captcha,
      getCaptcha: this._getCaptcha.bind(this),
      onSubmit: this._onSubmit.bind(this),
    }
    return (
      <Layout className='full-layout'>
        <Header>
          <LoginHeader />
        </Header>
        <Content>
          <div className="login-content-main">
            <div className="login-content-wrp">
              <div className="login-content">
                <div className="login-form-wrp">
                  <LoginForm {...loginFormProps} />
                </div>
              </div>
            </div>
          </div>
        </Content>
        <Footer>
          <CustomFooter
            menulist={footerMenuList}
            copyright="Copyright @2015-2025 Wizlong Ltd. All Rights Reserved."
            beian="沪ICP备06024976号-31"
          />
        </Footer>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { captcha, login } = state;
  const imageCaptcha = modelUtils.getModelEntity(captcha, 'captcha@getImageCaptcha');
  const captchaCode = modelUtils.getModelEntity(captcha, 'captcha@getCaptchaCode');
  const doLogin = modelUtils.getModelEntity(login, 'login@doLogin');
  const load = modelUtils.getLoadingState(state, ['captcha', 'login']);
  return {
    imageCaptcha,
    doLogin,
    captchaCode,
    ...load
  };
};

export default connect(mapStateToProps)(Login);
